<template>
  <b-col sm="8" md="6" lg="4" xl="3" class="mt-5">

    <b-card
        tag="article"
        class="h-60 p-0 shadow card-gray-light" 
        :img-src="require('@/assets/card-curso.jpg')"
         style="border: 1px solid #011e62;"
    >
      <a :href="'/ver/curso/' + this.curso.url_public"
         target="_blank"
         class="text-decoration-none">
        <b-card-text class="mt-1">
          <h5 class="font-weight-bold font-orange">
              <i class="fas fa-medal"></i>
              {{ curso.percentage + '% Match' }}
          </h5>
          <h6 class="font-weight-bold font-blue text-left mt-1 mb-2">
            {{ curso.title }} <b-badge v-if="curso.descuento != null && curso.descuento != 'null' && exh <= curso.fecha_descuento" variant="warning" >-{{curso.descuento}}% Descuento</b-badge>
          </h6>
          <p class="badge-primary badge shadow" style="font-size: 12px;">
            <i class="fas fa-comment-dollar mr-2"></i>
                <template v-if="curso.price_val == 'Si'"> 
                   {{ curso.price | currency }}
                </template>
                <template v-else>
                  Gratis
                </template>
          </p>
          <p class="font-blue font-weight-bold" >
            <i class="fa fa-location-arrow" aria-hidden="true"></i>
            {{ curso.location}}<br>
            <small class="font-weight-light font-gray-dark">
              {{ curso.created_at | moment('MMMM YYYY') }}
            </small> 
          </p> 
        </b-card-text>
      </a>
    </b-card>

  </b-col>

<!--  <div class="row p-0">-->
<!--    <div class="col">-->
<!--      <h5 class="font-weight-bold font-orange">-->
<!--        <i class="fas fa-medal"></i>-->
<!--        {{ curso.percentage + '% Match' }}-->
<!--      </h5>-->
<!--    </div>-->
<!--    <div class="col p-0">-->
<!--      <small class="badge-primary badge shadow text-right">-->
<!--        <i class="fas fa-comment-dollar mr-2"></i>-->
<!--        {{ curso.price | currency }}-->
<!--      </small>-->
<!--    </div>-->
<!--  </div>-->

</template>

<script>
  import moment from "moment"
export default {
  name: "CourseRecomendation",
    data() {
      return {
        exh:moment().format("YYYY-MM-DD")
      }
    },
  props: {
    curso: {
      type: Object,
      required: true,
    }
  },
  methods: {
    verCurso() {
      this.$router.push({
        name: 'course-view',
        params: {
          url_public: this.curso.url_public
        }
      })
      this.$router.go()
    }
  }
}
</script>

<style scoped lang="scss">
.card-img, .card-img-top, .card-img-bottom {
  height: 50%;
}

.card-gray-light {
  background: #fbfbfb;
}

.add-padding {
  padding-top: 1.5rem;
  padding-right: .5rem;
  padding-bottom: 1.5rem;
  padding-left: .5rem;
}

.box {
  width: 104px;
  height: 80px;
  background: #CCC;
  overflow: hidden;
}

.box img {
  width: 100%;
  height: auto;
}

@supports (object-fit: cover) {
  .box img {
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/#public/curse/components/home/CourseRecomendation.vue